import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';

import ImportedTag from '@components/ImportedTag';
import LoaderComponent from '@components/LoaderComponent';
import MaterialRoadmapView from '@components/MaterialRoadmapView';
import { toastError, toastSuccess } from '@components/Toast';

import UploadImage from '@features/designTool/components/UploadImage';
import Fabric from '@features/materials/components/Fabric';
import MaterialInventory from '@features/materials/components/MaterialInventory';
import TrimsAndAccessories from '@features/materials/components/TrimsAndAccessories';
import TagSupplier from '@features/supplier/component/TagSupplier';
import Embelishment from '@features/materials/components/Embelishment';
import Garments from '@features/materials/components/Garments';
import MaterialCardContainer from '@features/materials/components/MaterialCardContainer';
import ProductList from '@features/materials/components/ProductList';
import Washing from '@features/materials/components/Washing';

import { fetchEnumFilter } from '@store/design/action';
import {
	fetchBrandingDetails,
	fetchEmbellishmentDetails,
	fetchFabricDetails,
	fetchGarmentsDetails,
	fetchTrimsDetails,
	fetchWashingDetails
} from '@store/material/action';
import {
	getBrandingDetails,
	getGarmentsDetails,
	getMaterialsDetails,
	getTrimsDetails
} from '@store/reducers';
import { fetchSupplier } from '@store/supplier/action';

import ApiClient from '@lib/apiClient';

import {
	docType,
	enumObj,
	FABRIC_TYPE_LIST,
	getConsumptionByKeyNameWise,
	isFabric,
	MATERIAL_TITLE_NAME,
	whichUserMaterialEditAndDuplicateAndDeleteCheck
} from '@utils/MaterialsUtil';
import {
	addImageSuffix,
	capitalizeFirstLetter,
	changeDateFormat,
	isValidFile,
	onPreventDefaultAll
} from '@utils/Util';

import { BASE_URL, MATERIALS_TYPE } from '@/constants/constant';

import MatchingFaricAndTrims from '@/features/materials/components/MatchingFaricAndTrims';

const MaterialDetails = () => {
	const [, setViewType] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [, setSupplierName] = useState('');
	const [, setSupplierId] = useState(null);
	const [selectedSupplier, setSelectedSupplier] = useState(null);
	const [details, setDetails] = useState(null);
	const [isShowTag, setIsShowTag] = useState(false);
	const [page] = useState(0);
	const [sort] = useState('id,desc');
	const [, setPriceType] = useState(null);
	const [, setCapacityType] = useState(null);
	const [, setPrice] = useState(null);
	const [, setCapacity] = useState(null);
	const [, setLeadTimeInDays] = useState(null);
	const [, setItemRating] = useState(null);
	const [, setMoq] = useState(null);
	const [, setDescription] = useState('');
	const [isEdit, setIsEdit] = useState('');
	const [isInventory, setIsInventory] = useState(false);
	const [selectedItem, setSelectedItem] = useState(null);
	const [, setErrors] = useState({});
	const [multipleImageData, setMultipleImageData] = useState([]);
	const [, setSelectedImage] = useState(null);
	const [materialType, setMaterialType] = useState(null);
	const [fabricType, setFabricType] = useState('');
	const [consumptionUnit, setConsumptionUnit] = useState('');
	const [subCategoryType, setSubCategoryType] = useState({});
	const [usedProductlist] = useState(null);
	const [searchParams] = useSearchParams();
	const [activeStep, setActiveStep] = useState('FABRIC');

	const dispatch = useDispatch();
	const { id } = useParams();
	const submitRef = useRef();

	const materialDetails = useSelector(
		activeStep === 'FABRIC'
			? getMaterialsDetails
			: activeStep === 'TRIMS'
				? getTrimsDetails
				: activeStep === 'ACCESSORIES'
					? getBrandingDetails
					: activeStep === 'GARMENTS'
						? getGarmentsDetails
						: null
	);
	const navigate = useNavigate();

	const renderItem = (type) => {
		setIsLoading(true);
		switch (type) {
			case 'GARMENTS':
				return dispatch(fetchGarmentsDetails(id)).finally(() => {
					intialValueSet();
				});
			case 'FABRIC':
				return dispatch(fetchFabricDetails(id)).finally(() => {
					intialValueSet();
				});
			case 'EMBELLISHMENT':
				return dispatch(fetchEmbellishmentDetails(id)).finally(() => {
					intialValueSet();
				});
			case 'TRIMS_ACCESSORIES':
				return dispatch(fetchTrimsDetails(id)).finally(() => {
					intialValueSet();
				});
			case 'TRIMS':
				return dispatch(fetchTrimsDetails(id)).finally(() => {
					intialValueSet();
				});
			case 'BRANDING':
				return dispatch(fetchBrandingDetails(id)).finally(() => {
					intialValueSet();
				});
			case 'ACCESSORIES':
				return dispatch(fetchBrandingDetails(id)).finally(() => {
					intialValueSet();
				});
			case 'WASHING':
				return dispatch(fetchWashingDetails(id)).finally(() => {
					intialValueSet();
				});
			default:
				break;
		}
	};

	const intialValueSet = () => {
		setIsEdit('');
		setIsLoading(false);
		setIsInventory(false);
	};

	const getConsumptionUnitForMaterilaDetails = () => {
		let materialType = materialDetails?.data?.materialType?.toUpperCase();
		if (isFabric(materialType)) {
			setConsumptionUnit(getConsumptionByKeyNameWise(materialDetails?.data?.fabricType, 'unit'));
		} else if ([MATERIALS_TYPE.TRIMS, MATERIALS_TYPE.BRANDING].includes(materialType)) {
			setConsumptionUnit(materialDetails?.data?.subCategoryType?.consumptionUnit);
		}
	};

	// const getProductList = async () => {
	// 	const data = await fetchMaterialProducts(id);
	// 	setUsedProductList(data);
	// };

	useEffect(() => {
		const type = searchParams.get('type') || 'FABRIC';
		setMaterialType(type);
		renderItem(type);
		setActiveStep(type);
		document.body.addEventListener('keydown', onKeyDown);
		return () => {
			document.body.removeEventListener('keydown', onKeyDown);
		};
	}, [id]);

	const onKeyDown = (e) => {
		onPreventDefaultAll(e, document.activeElement, submitRef.current);
	};

	useEffect(() => {
		setDetails(materialDetails);
		if (materialDetails?.data?.subCategoryType) {
			setSubCategoryType(materialDetails?.data?.subCategoryType);
		}
		getConsumptionUnitForMaterilaDetails();
		if (materialDetails?.data?.documentResponseList) {
			setMultipleImageData(materialDetails.data.documentResponseList);
			setSelectedImage(materialDetails.data.documentResponseList[0]);
		} else {
			setMultipleImageData([]);
			setSelectedImage(null);
		}
	}, [materialDetails]);

	// useEffect(() => {
	// 	dispatch(fetchMaterialSuppliers(page, 20, id, sort)).finally(() => {
	// 		setIsLoading(false);
	// 	});
	// }, [page]);

	const onShowTag = (type) => {
		setViewType(type);
		setIsShowTag(true);
		dispatch(fetchEnumFilter('info.nitex.app.materials.UnitType')).finally(() => {
			setIsLoading(false);
		});
		dispatch(fetchSupplier(page, 20, '', details?.data.materialType, sort)).finally(() => {
			setIsLoading(false);
		});
	};

	const handleClose = () => {
		setSelectedSupplier(null);
		setIsShowTag(false);
		setIsLoading(false);
		setSupplierId(null);
		setSupplierName('');
		setPriceType(null);
		setCapacityType(null);
		setPrice(null);
		setCapacity(null);
		setLeadTimeInDays(null);
		setItemRating(null);
		setMoq(null);
		setDescription('');
		// if(title === MATERIAL_TITLE_NAME.TRIMS)
		// dispatch(fetchMaterialSuppliers(page, 20, id, sort)).finally(() => {
		// 	setIsLoading(false);
		// });
		setErrors({});
	};

	const renderDetails = () => {
		if (details?.type === MATERIALS_TYPE.FABRIC) {
			return renderFabricDetails();
		} else if ([MATERIALS_TYPE.TRIMS_ACCESSORIES, MATERIALS_TYPE.BRANDING].includes(details?.type)) {
			return renderTrimsOrAccessoriesDetails();
		} else {
			return renderOtherMaterialDetails();
		}
	};

	const onclose = (value) => {
		if (value && value === 'updated') {
			renderItem(isEdit);
		} else {
			setIsEdit('');
			setIsInventory(false);
		}
	};
	const onEdit = (item) => {
		// if (item?.data?.isExpired) return;
		setSelectedItem({ ...item?.data, materialId: item?.data.id });
		setIsEdit(item.type);
	};

	const onEditForInventory = (item) => {
		setSelectedItem({ ...item?.data, materialId: item?.data.id });
		setIsEdit(item.type);
		setIsInventory(true);
	};

	const renderCharacteristics = () => {
		let requiredTypes = [
			'SUPPLIER_CHARACTERISTIC_DRAPPY',
			'SUPPLIER_CHARACTERISTIC_HAND_FEEl',
			'SUPPLIER_CHARACTERISTIC_FINISH_EFFECT',
			'SUPPLIER_CHARACTERISTIC_LOOK'
		];
		let filterTags = details?.data?.fixedTagResponseList?.filter((item) =>
			requiredTypes.includes(item.type)
		);
		return filterTags?.map((item) => (
			<span key={`chip_item_${item.id}`} className="status gray-1 mr-2">
				{item.text}
			</span>
		));
	};

	const renderFinishAndWash = () => {
		let filterTags = details?.data?.fixedTagResponseList?.filter(
			(item) => item.type === 'SUPPLIER_FINISH' || item.type === 'SUPPLIER_WASH'
		);
		return filterTags?.map((item) => (
			<span key={`chip_item_${item.id}`} className="status gray-1 mr-2">
				{item.text}
			</span>
		));
	};

	const multipleFileUpload = (e) => {
		let files = [];
		let modifiedFileList = [];
		files = [...e.target.files];
		let invalidFiles = files.filter((item) => item.size > 1000000);
		if (invalidFiles.length > 0) {
			toastError('Each image size should be less than 1mb');
			return;
		}
		if (files.length !== 0 && invalidFiles.length === 0) {
			files.forEach((file) => {
				if (file) {
					if (isValidFile(file, 'image')) {
						let data = {
							entityId: materialDetails ? materialDetails?.data?.id : null,
							name: file?.name,
							docMimeType: file?.type,
							documentType: 'MATERIAL_DESIGN',
							base64Str: '',
							size: file?.size
						};
						let reader = new FileReader();
						reader.readAsDataURL(file);
						reader.onload = () => {
							data.base64Str = reader.result;
							modifiedFileList.push(data);
						};
						reader.onerror = function (error) {
							toastError(error);
						};
					}
				}
			});
			setTimeout(() => {
				if (modifiedFileList?.length > 0) {
					multipleImageUpload(modifiedFileList).then().catch();
				}
			}, 100);
		}
	};
	const multipleImageUpload = async (data) => {
		setIsLoading(true);
		await ApiClient.POST('getBulkUploadMaterialDoc', data)
			.then(({ data }) => {
				setIsLoading(false);
				if (data) {
					let docType = data.map((imageInfo) => imageInfo.docType);
					let tmpArray = multipleImageData?.filter((obj) => !docType.includes(obj.docType));

					if (tmpArray.length > 0) setMultipleImageData([...tmpArray, ...data]);
					else setMultipleImageData(data);
				}
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};
	const singleImageUpload = async (imageInfo) => {
		delete imageInfo.productId;
		delete imageInfo.documentGroup;
		if (validateFileSize(imageInfo.size)) {
			imageInfo.entityId = materialDetails?.data?.id ? materialDetails?.data?.id : null;
			setIsLoading(true);
			await ApiClient.POST('getUploadMaterialDoc', imageInfo)
				.then(({ data }) => {
					setIsLoading(false);
					if (data) {
						let tmpArray = multipleImageData?.filter((obj) => data.docType !== obj.docType);

						if (tmpArray?.length > 0) setMultipleImageData([...tmpArray, data]);
						else setMultipleImageData([data]);
					}
				})
				.catch(({ response }) => {
					setIsLoading(false);
					if (response && response.data && response.data.message) {
						toastError(response.data.message);
					} else {
						toastError('Request was unsuccessful.');
					}
				});
		}
	};
	const validateFileSize = (size) => {
		if (size > 1000000) {
			toastError('Please upload file less than 1mb');
			return false;
		} else {
			return true;
		}
	};
	const removeImage = async (docId) => {
		if (materialDetails?.data?.id)
			await ApiClient.DELETE(
				`${BASE_URL}/material/${materialDetails?.data?.id}/documents/${docId}`,
				'',
				'',
				true
			)
				.then(({ data }) => {
					setIsLoading(false);
					if (data && data.success) {
						toastSuccess(data.message);
						imageRemoveInArray(docId);
					}
				})
				.catch(({ response }) => {
					setIsLoading(false);
					if (response && response.data && response.data.message) {
						toastError(response.data.message);
					} else {
						toastError('Request was unsuccessful.');
					}
				});
		else {
			imageRemoveInArray(docId);
		}
	};
	const imageRemoveInArray = (docId) => {
		let tmpArray = multipleImageData?.filter((obj) => docId !== obj.id);
		setMultipleImageData(tmpArray);
	};

	const getImageData = (multipleImageData, documentType) => {
		return multipleImageData?.find((item) => item.docType === documentType);
	};

	useEffect(() => {
		if (details?.data?.fabricType) {
			let value = details?.data?.fabricType;
			if (value) {
				setFabricType(FABRIC_TYPE_LIST.find((items) => value.includes(items.name))?.weightUnit);
			}
		}
	}, [details?.data?.fabricType]);

	const backButton = () => {
		if (MATERIALS_TYPE.FABRIC === details?.type) {
			navigate('/materials/view');
		} else if (MATERIALS_TYPE.TRIMS_ACCESSORIES === details?.type) {
			navigate('/materials/view?type=TRIMS');
		} else if (MATERIALS_TYPE.BRANDING === details?.type) {
			navigate('/materials/view?type=ACCESSORIES');
		}
	};

	const isImportedFabric = (item) => {
		return item?.isImported;
	};

	const ColorItem = ({ color, label }) => (
		<p className="regular-14 d-flex align-items-center mb-1">
			<span className="color-icon mr-1" style={{ backgroundColor: color?.hexCode }} />
			{label === 'Color' && <span>{color?.name}</span>}
			{color?.code && <span>{color?.code}</span>}
			{label === 'Fabric TCX Color' && <span>, {color?.name}</span>}
		</p>
	);

	const renderColorList = (label, colorData, colorType) => {
		const filteredColorData =
			label === 'Color' || (label === 'Fabric TCX Color' && colorType === 'SOLID')
				? colorData
				: colorData?.compositeColorList;

		return (
			<p className="regular-14 d-flex align-items-start mb-12">
				<span className="info-label">{label}</span>
				<span className="mx-2">:</span>
				<div>
					{label === 'Fabric TCX Color' && colorType === 'SOLID' ? (
						<ColorItem color={colorData} label={label} />
					) : (
						filteredColorData?.length > 0 &&
						filteredColorData.map((color) => (
							<ColorItem key={color?.id || color?.name} color={color} label={label} />
						))
					)}
				</div>
			</p>
		);
	};

	const renderTopHeaderInfo = () => {
		if (
			[MATERIALS_TYPE.FABRIC, MATERIALS_TYPE.TRIMS_ACCESSORIES, MATERIALS_TYPE.BRANDING].includes(
				details?.type
			)
		) {
			return (
				<div className="d-flex px-4 py-2 justify-content-between align-items-center">
					<div className="d-flex align-items-center">
						<img
							src={`${process.env.PUBLIC_URL}/icons/Left-arrow.svg`}
							alt="back"
							className="cursor-pointer"
							onClick={() => backButton()}
						/>
						<p className="semibold-14">{MATERIAL_TITLE_NAME[details?.type]}</p>
					</div>
					<div className="d-flex align-items-center material-buttons">
						<div className="dashboard-container material-images-uplodaer">
							<div className="presentations-tab">
								<div className="inline-upload text-center">
									<label htmlFor="multipleUpload">Upload all</label>
									<input
										type="file"
										className="file-upload"
										id="multipleUpload"
										name="image"
										onClick={(e) => (e.target.value = null)}
										onChange={(e) => {
											// if (details.isExpired && whichUserInventoryCheck()) return;
											multipleFileUpload(e);
										}}
										accept="image/*"
										multiple={true}
									/>
								</div>
							</div>
						</div>
						{whichUserMaterialEditAndDuplicateAndDeleteCheck() && (
							<button className="button outline size32 ml-12" onClick={() => onEdit(details)}>
								Edit {MATERIAL_TITLE_NAME[details?.type]}
							</button>
						)}
						{!details?.isExpired && (
							<button
								className="button size32 ml-12"
								onClick={() => onEditForInventory(details)}
							>
								Update inventory
							</button>
						)}
					</div>
				</div>
			);
		} else {
			return (
				<div className="page-title-area pb-3">
					<h1 className="semibold-16">Material details</h1>
				</div>
			);
		}
	};

	const renderFabricDetails = () => {
		return (
			<>
				<div className="material-item-box">
					<div className="material-item-heading-info d-flex justify-content-between pb-3">
						<div className="d-flex align-items-center">
							<p className="regular-14 gray_dark_02 text-uppercase mr-1">
								REFERENCE NO
								<span className="semibold-14 ml-2">
									{materialDetails?.data?.referenceNumber}
								</span>
							</p>

							<p className="regular-14 gray_dark_02 text-uppercase mx-3">
								INVENTORY{' '}
								<span
									className={
										materialDetails?.data?.stockQuantity > 0
											? 'inventory-value'
											: 'inventory-value empty'
									}
								>
									{parseFloat(materialDetails?.data?.stockQuantity || 0).toFixed(2) || '00'}{' '}
									{consumptionUnit}
								</span>
							</p>
							{materialDetails?.data?.lastReceivedDate && (
								<p className="regular-14 gray_dark_02 ml-1">
									(Last received:
									{changeDateFormat(
										materialDetails?.data?.lastReceivedDate,
										'YYYY-MM-DD',
										'DD MMM, YY'
									) || ''}
									)
								</p>
							)}
						</div>
					</div>
					<div className="dashboard-container material-images-uplodaer">
						<div className="presentations-tab">
							<div className="presentations-upload-image-container">
								<UploadImage
									document={getImageData(multipleImageData, docType.MATERIAL_FEATURE_IMAGE)}
									title="Back side folded & Feature image (-B)"
									docType={docType.MATERIAL_FEATURE_IMAGE}
									removeImage={removeImage}
									singleImageUpload={singleImageUpload}
								/>
								{/* <UploadImage
									document={getImageData(multipleImageData, docType.MATERIAL_FRONT_IMAGE)}
									title="Front (-F)"
									docType={docType.MATERIAL_FRONT_IMAGE}
									removeImage={removeImage}
									singleImageUpload={singleImageUpload}
								/> */}
								<UploadImage
									document={getImageData(multipleImageData, docType.MATERIAL_DETAILS_IMAGE)}
									title="Details (-D)"
									docType={docType.MATERIAL_DETAILS_IMAGE}
									removeImage={removeImage}
									singleImageUpload={singleImageUpload}
								/>
								<div className="material-item-details">
									<div className="one-half">
										<p className="regular-14 mb-1">
											<span className="info-label">SUPPLIER & REF</span>{' '}
											<span className="mx-2">:</span>
											<span className="regular-14 text-uppercase gray_dark_01">
												<Link
													onClick={(e) => e.stopPropagation()}
													className="f-title hover-underline"
													to={`/suppliers/view/${
														materialDetails?.data?.supplierList &&
														materialDetails?.data?.supplierList[0]?.supplierId
													}`}
													target="_blank"
												>
													{materialDetails?.data?.supplierList &&
														materialDetails?.data?.supplierList[0]?.name}
												</Link>
											</span>
										</p>
										<p className="regular-14 mb-3">
											<span className="info-label"></span>{' '}
											<span className="mx-2 text-white">:</span>
											<span className="semibold-14 mr-2 d-flex flex-column">
												{materialDetails?.data?.supplierList &&
													materialDetails?.data?.supplierList[0]?.referenceNumber}
												{isImportedFabric(materialDetails?.data) && <ImportedTag />}
											</span>
										</p>
										<p className="regular-14 mb-1 mt-1">
											<span className="info-label">Category</span>{' '}
											<span className="mx-2">:</span>
											<span className="weight-500">
												{capitalizeFirstLetter(details?.data?.fabricType)?.replace(
													'_',
													'-'
												)}
												, {details?.data?.construction}
											</span>
										</p>
										<p className="regular-14 mb-1">
											<span className="info-label">Composition</span>{' '}
											<span className="mx-2">:</span>
											<span className="weight-500">
												{details?.data?.compositionDetails}
											</span>
										</p>
										<p className="regular-14 mb-1">
											<span className="info-label">Construction</span>{' '}
											<span className="mx-2">:</span>
											<span className="weight-500">
												{details?.data?.constructionDetails}
											</span>
										</p>
										<p className="regular-14 mb-1">
											<span className="info-label">Weight</span>{' '}
											<span className="mx-2">:</span>
											<span className="weight-500">
												{details?.data?.gsm
													? details?.data?.gsm + ' ' + fabricType
													: ''}
											</span>
										</p>
										<p className="regular-14 mb-1">
											<span className="info-label">Cuttable-Width</span>{' '}
											<span className="mx-2">:</span>
											<span className="weight-500">
												{details?.data?.cuttableWidth
													? details?.data?.cuttableWidth + ' INCH '
													: ''}
											</span>
										</p>
										{details?.data?.stripeType && (
											<p className="regular-14 mb-1">
												<span className="info-label">Stripe details </span>{' '}
												<span className="mx-2">:</span>
												<span className="weight-500">
													{capitalizeFirstLetter(
														details?.data?.stripeType
													)?.replace('_', ' ')}
													, {details?.data?.stripeTypeDetails}
												</span>
											</p>
										)}

										{renderColorList(
											'Color',
											details?.data?.materialColorResponse?.colorGroupResponseList,
											details?.data?.materialColorResponse?.colorType?.constant
										)}
										{renderColorList(
											'Fabric TCX Color',
											details?.data?.materialColorResponse?.colorResponse,
											details?.data?.materialColorResponse?.colorType?.constant
										)}
									</div>
									<div className="one-half">
										<p className="regular-14 d-flex align-items-center mb-2 mt-3">
											<span className="info-label">Finish & Wash</span>{' '}
											<span className="mx-2">:</span>
											{renderFinishAndWash()}
										</p>
										<p className="regular-14 d-flex align-items-center">
											<span className="info-label">Characteristic</span>{' '}
											<span className="mx-2">:</span>
											{renderCharacteristics()}
										</p>
										<p className="regular-14 mb-1 mt-3">
											<span className="info-label">Base</span>{' '}
											<span className="mx-2">:</span>
											<span className="weight-500">
												{capitalizeFirstLetter(details?.data?.fabricBase)}
											</span>
										</p>
										<p className="regular-14 mb-1">
											<span className="info-label">Price range</span>{' '}
											<span className="mx-2">:</span>
											<span className="weight-500">
												{' '}
												{details?.data?.pricePoint === 'HIGH'
													? 'Premium'
													: details?.data?.pricePoint === 'LOW'
														? 'Regular'
														: capitalizeFirstLetter(details?.data?.pricePoint)}
											</span>
										</p>
										<p className="regular-14 d-flex align-items-center">
											<span className="info-label">Brand</span>{' '}
											<span className="mx-2">:</span>
											{details?.data?.brandResponseList?.map((brand) => (
												<span className="status gray-1 radius mr-2" key={brand?.id}>
													{brand?.name}
												</span>
											))}
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="text-right nitex-logo">
						<img src={`${process.env.PUBLIC_URL}/icons/nitex-logo.svg`} alt="nitex" />
					</div>
				</div>
			</>
		);
	};
	const renderTrimsOrAccessoriesDetails = () => {
		return (
			<>
				<div className="material-item-box">
					<div className="material-item-heading-info d-flex justify-content-between pb-3">
						<div className="d-flex align-items-center">
							<p className="regular-14 gray_dark_02 text-uppercase mr-1">
								REFERENCE NO
								<span className="semibold-14 ml-2">
									{materialDetails?.data?.referenceNumber}
								</span>
							</p>

							<p className="regular-14 gray_dark_02 text-uppercase mx-3">
								INVENTORY{' '}
								<span
									className={
										materialDetails?.data?.stockQuantity > 0
											? 'inventory-value'
											: 'inventory-value empty'
									}
								>
									{parseFloat(materialDetails?.data?.stockQuantity || 0).toFixed(2) || '00'}{' '}
									{consumptionUnit}
								</span>
							</p>
							{materialDetails?.data?.lastReceivedDate && (
								<p className="regular-14 gray_dark_02 ml-1">
									(Last received:
									{changeDateFormat(
										materialDetails?.data?.lastReceivedDate,
										'YYYY-MM-DD',
										'DD MMM, YY'
									) || ''}
									)
								</p>
							)}
						</div>
					</div>
					<div className="dashboard-container material-images-uplodaer">
						<div className="presentations-tab">
							<div className="presentations-upload-image-container">
								<UploadImage
									document={getImageData(multipleImageData, docType.MATERIAL_FEATURE_IMAGE)}
									title="Back side folded & Feature image (-B)"
									docType={docType.MATERIAL_FEATURE_IMAGE}
									removeImage={removeImage}
									singleImageUpload={singleImageUpload}
								/>
								<UploadImage
									document={getImageData(multipleImageData, docType.MATERIAL_DETAILS_IMAGE)}
									title="Details (-D)"
									docType={docType.MATERIAL_DETAILS_IMAGE}
									removeImage={removeImage}
									singleImageUpload={singleImageUpload}
								/>
								<div className="material-item-details">
									<div className="one-half">
										<p className="regular-14 mb-1">
											<span className="info-label">SUPPLIER & REF</span>{' '}
											<span className="mx-2">:</span>
											<span className="regular-14 text-uppercase gray_dark_01">
												<Link
													onClick={(e) => e.stopPropagation()}
													className="f-title hover-underline"
													to={`/suppliers/view/${materialDetails?.data?.supplier?.supplierId}`}
													target="_blank"
												>
													{materialDetails?.data?.supplier?.name}
												</Link>
											</span>
										</p>
										<p className="regular-14 mb-3">
											<span className="info-label"></span>{' '}
											<span className="mx-2 text-white">:</span>
											<span className="semibold-14 mr-2">
												{materialDetails?.data?.supplier?.referenceNumber}
											</span>
										</p>
										<p className="regular-14 mb-1 mt-1">
											<span className="info-label">Category</span>{' '}
											<span className="mx-2">:</span>
											<span className="weight-500">
												{details?.data?.subCategoryType?.name}
											</span>
										</p>
										<p className="regular-14 mb-1">
											<span className="info-label">Material quality</span>{' '}
											<span className="mx-2">:</span>
											<span className="weight-500">
												{details?.data?.materialQuality?.text}
											</span>
										</p>
										<p className="regular-14 mb-1">
											<span className="info-label">Sustainability</span>{' '}
											<span className="mx-2">:</span>
											<span className="weight-500">
												{details?.data?.sustainability?.text}
											</span>
										</p>
										<p className="regular-14 mb-1">
											<span className="info-label">Technique</span>{' '}
											<span className="mx-2">:</span>
											<span className="weight-500">
												{details?.data?.technique?.text}
											</span>
										</p>
										{details?.data?.widthFromEdges && (
											<p className="regular-14 mb-1">
												<span className="info-label">Width(edges)</span>{' '}
												<span className="mx-2">:</span>
												<span className="weight-500">
													{details?.data?.widthFromEdges +
														' ' +
														subCategoryType?.widthFromEdges}
												</span>
											</p>
										)}
										{details?.data?.diameter && (
											<p className="regular-14 mb-1">
												<span className="info-label">Diameter</span>{' '}
												<span className="mx-2">:</span>
												<span className="weight-500">
													{details?.data?.diameter +
														' ' +
														subCategoryType?.diameter}
												</span>
											</p>
										)}
										{details?.data?.widthInside && (
											<p className="regular-14 mb-1">
												<span className="info-label">Width(Inside)</span>{' '}
												<span className="mx-2">:</span>
												<span className="weight-500">
													{details?.data?.widthInside +
														' ' +
														subCategoryType?.widthInside}
												</span>
											</p>
										)}
										{details?.data?.zipperNumber && (
											<p className="regular-14 mb-1">
												<span className="info-label">Zipper number</span>{' '}
												<span className="mx-2">:</span>
												<span className="weight-500">
													{details?.data?.zipperNumber +
														' ' +
														subCategoryType?.zipperNumber}
												</span>
											</p>
										)}
										{details?.data?.length && (
											<p className="regular-14 mb-1">
												<span className="info-label">Length</span>{' '}
												<span className="mx-2">:</span>
												<span className="weight-500">
													{details?.data?.length + ' ' + subCategoryType?.length}
												</span>
											</p>
										)}
										{details?.data?.height && (
											<p className="regular-14 mb-1">
												<span className="info-label">Height</span>{' '}
												<span className="mx-2">:</span>
												<span className="weight-500">
													{details?.data?.height + ' ' + subCategoryType?.height}
												</span>
											</p>
										)}
										{details?.data?.numberOfHole && (
											<p className="regular-14 mb-1">
												<span className="info-label">Number of hole</span>{' '}
												<span className="mx-2">:</span>
												<span className="weight-500">
													{details?.data?.numberOfHole +
														' ' +
														subCategoryType?.numberOfHole}
												</span>
											</p>
										)}
										<p className="regular-14 mb-1">
											<span className="info-label">Trims details</span>{' '}
											<span className="mx-2">:</span>
											<span className="weight-500">{details?.data?.details}</span>
										</p>
										<p className="regular-14 mb-1">
											<span className="info-label">Brand specific?</span>{' '}
											<span className="mx-2">:</span>
											<span className="weight-500">
												{details?.data?.specificBrandResponse?.name}
											</span>
										</p>

										{renderColorList(
											'Color',
											details?.data?.materialColorResponse?.colorGroupResponseList,
											details?.data?.materialColorResponse?.colorType?.constant
										)}
										{renderColorList(
											'Fabric TCX Color',
											details?.data?.materialColorResponse?.colorResponse,
											details?.data?.materialColorResponse?.colorType?.constant
										)}
									</div>
									<div className="one-half">
										<p className="regular-14 d-flex align-items-center">
											<span className="info-label">Brand</span>{' '}
											<span className="mx-2">:</span>
											{materialDetails?.data?.supplier?.brandResponseList?.map(
												(brand) => (
													<span
														className="status gray-1 radius mr-2"
														key={brand?.id}
													>
														{brand?.name}
													</span>
												)
											)}
										</p>
										<p className="regular-14 mb-1">
											<span className="info-label">Price range</span>{' '}
											<span className="mx-2">:</span>
											<span className="weight-500">
												{' '}
												{details?.data?.pricePoint === 'HIGH'
													? 'Premium'
													: details?.data?.pricePoint === 'LOW'
														? 'Regular'
														: capitalizeFirstLetter(details?.data?.pricePoint)}
											</span>
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="text-right nitex-logo">
						<img src={`${process.env.PUBLIC_URL}/icons/nitex-logo.svg`} alt="nitex" />
					</div>
				</div>
			</>
		);
	};

	const renderOtherMaterialDetails = () => {
		return (
			<>
				<div className="fabric-details-box bg-white shadow-1dp d-flex justify-content-between">
					<div className="fabric-box-left d-flex">
						<div className="fabric-image without-fabric">
							<img
								// _xthumbnail
								src={addImageSuffix(details?.data?.documentPath, '_xthumbnail')}
								onError={(e) => {
									e.target.onerror = null;
									e.target.src = `${process.env.PUBLIC_URL}/images/noImage.png`;
								}}
								alt="material-image"
								className={'large'}
							/>
						</div>
						<div className="fabric-categories">
							<div className="container">
								<div className="row">
									<div className="col-md-12">
										<h3 className="semibold-16 pb-1">{details?.data.name}</h3>
									</div>

									{details?.data.referenceNumber && (
										<div className="col-md-3 mb-3">
											<p className="regular-14">Ref number</p>
											<p className="semibold-14">{details?.data?.referenceNumber}</p>
										</div>
									)}

									{details?.data.marketResponse && (
										<div className="col-md-3 mb-3">
											<p className="regular-14">Market</p>
											<p className="semibold-14">
												{details?.data?.marketResponse.name}
											</p>
										</div>
									)}

									{details?.data.categoryResponse && (
										<div className="col-md-3 mb-3">
											<p className="regular-14">Category</p>
											<p className="semibold-14">
												{details?.data?.categoryResponse.name}
											</p>
										</div>
									)}

									{details?.data.trimsCategoryResponse && (
										<div className="col-md-3 mb-3">
											<p className="regular-14">Category</p>
											<p className="semibold-14">
												{details?.data?.trimsCategoryResponse.value}
											</p>
										</div>
									)}

									{details?.data.brandingCategoryResponse && (
										<div className="col-md-3 mb-3">
											<p className="regular-14">Category</p>
											<p className="semibold-14">
												{details?.data?.brandingCategoryResponse.value}
											</p>
										</div>
									)}

									{details?.data.categoryName && (
										<div className="col-md-3 mb-3">
											<p className="regular-14">Category</p>
											<p className="semibold-14">{details?.data.categoryName}</p>
										</div>
									)}

									{details?.data.subCategory && (
										<div className="col-md-3 mb-3">
											<p className="regular-14">Sub category</p>
											<p className="semibold-14">{details?.data.subCategory}</p>
										</div>
									)}

									{details?.data.composition && (
										<div className="col-md-3 mb-3">
											<p className="regular-14">Composition</p>
											<p className="semibold-14">
												{capitalizeFirstLetter(details?.data.composition)}
											</p>
										</div>
									)}

									{details?.data.washProcessName && (
										<div className="col-md-3 mb-3">
											<p className="regular-14">Wash process</p>
											<p className="semibold-14">{details?.data.washProcessName}</p>
										</div>
									)}
								</div>
							</div>
						</div>
					</div>
					<div className="fabric-box-right text-right">
						<button className="button gray-outline size32" onClick={() => onEdit(details)}>
							Edit
						</button>
						<button className="button secondary size32 ml-2" onClick={() => onShowTag('TAG')}>
							Tag supplier
						</button>
					</div>
				</div>
			</>
		);
	};

	return (
		<LoaderComponent loading={isLoading}>
			{details?.type && <div className="top-header bg-gray">{renderTopHeaderInfo()}</div>}
			{details?.type && (
				<div className="body-content">
					{renderDetails()}
					{details?.type === MATERIALS_TYPE.FABRIC && (
						<div className="mt-3 bg-white p-4">
							<MaterialRoadmapView supplierList={materialDetails?.data?.supplierList} />
						</div>
					)}
					{(details.type === 'FABRIC' || details.type === 'TRIMS_ACCESSORIES') && (
						<MatchingFaricAndTrims
							materialId={id}
							referenceNumber={details?.data?.referenceNumber}
						/>
					)}
					<MaterialCardContainer
						materialType={details?.type === MATERIALS_TYPE.FABRIC ? 'FABRIC' : 'TRIMS'}
					/>

					<ProductList
						productList={usedProductlist}
						type={details?.type === MATERIALS_TYPE.FABRIC ? 'fabric' : 'trims'}
					/>
				</div>
			)}

			{materialType !== null && (
				<TagSupplier
					show={isShowTag}
					handleClose={handleClose}
					materialId={id}
					supplierType={'Supplier'}
					requestedPage="MATERIAL"
					materialType={materialType}
					callback={handleClose}
					supplierInfo={selectedSupplier}
				/>
			)}

			{isEdit === 'GARMENTS' && (
				<Garments materialData={selectedItem} isShow={true} onclose={onclose} viewType={'EDIT'} />
			)}
			{isEdit === 'FABRIC' && !isInventory && (
				<Fabric
					materialData={selectedItem}
					isShow={true}
					onclose={onclose}
					viewType={'Edit'}
					renderFrom={'MATERIAL'}
				/>
			)}
			{isInventory && (
				<MaterialInventory
					materialData={selectedItem}
					onclose={onclose}
					viewType={'updated'}
					consumptionUnit={consumptionUnit}
				/>
			)}
			{isEdit === 'EMBELLISHMENT' && (
				<Embelishment materialData={selectedItem} isShow={true} onclose={onclose} viewType={'EDIT'} />
			)}
			{isEdit === 'TRIMS_ACCESSORIES' && !isInventory && (
				<TrimsAndAccessories
					materialData={selectedItem}
					title={MATERIAL_TITLE_NAME.TRIMS}
					isAdd={false}
					isShow={true}
					onclose={onclose}
					viewType={'EDIT'}
					renderFrom={'MATERIAL_EDIT'}
				/>
			)}
			{isEdit === 'BRANDING' && !isInventory && (
				<TrimsAndAccessories
					materialData={selectedItem}
					title={MATERIAL_TITLE_NAME.BRANDING}
					isAdd={false}
					isShow={true}
					onclose={onclose}
					viewType={'EDIT'}
					renderFrom={enumObj.MATERIAL}
				/>
			)}
			{isEdit === 'WASHING' && (
				<Washing materialData={selectedItem} isShow={true} onclose={onclose} viewType={'EDIT'} />
			)}
		</LoaderComponent>
	);
};

export default MaterialDetails;
